module.exports = __webpack_public_path__ + "img/hiqor.effbb120.png";